import * as React from 'react';
import { LoadingSpinner } from '../../Common/LoadingSpinner';
import { SVG } from '../../Utils/SVG';
const authBackgroundImage = require('../../../images/banner-image.jpg');
const edgeOfPlayIconURL = require('../../../icons/large-logo.svg');
import './style.css';

export interface AuthPageProps {
  /* empty */
  loading: boolean;
}

export interface AuthPageState {
  /* empty */
}

export class AuthPage extends React.Component<AuthPageProps, AuthPageState> {
  render() {
    const { loading } = this.props;

    return (
      <div
        className="auth-page"
        style={{
          backgroundImage: `url(${authBackgroundImage})`
        }}
      >
        <div className="auth-page-content">
          <SVG className="auth-page-app-logo" src={edgeOfPlayIconURL} />
          {this.props.children}
          {loading ? (
            <div className="auth-page-loader-wrapper">
              <LoadingSpinner className="auth-page-loader" />
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

export default AuthPage;



// WEBPACK FOOTER //
// ./src/app/components/Auth/AuthPage/index.tsx